import axios from "../_helpers/axiosInstance.js";

const getProductStatuses = async () => {
    const response = await axios.get("product/status");
    return response.data.result;
};

export const publicStatusApi = {
    getProductStatuses
};
